import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { GlobalService } from "../global-service";
import { MessageService } from "primeng/api";

@Component({
  selector: "app-results",
  templateUrl: "./results.component.html",
  styleUrls: ["./results.component.css"],
})
export class ResultsComponent implements OnInit {
  ResultData: any=[]
  year: any = [];
  selectedYear: any;
  type: any = [];
  selectedType: any;
  constructor(
    private router: Router,
    public global: GlobalService,
    private route: ActivatedRoute,
    private messageService: MessageService
  ) {
    this.year = [
      { label: "2010", value: "2010" },
      { label: "2011", value: "2011" },
      { label: "2012", value: "2012" },
      { label: "2013", value: "2013" },
      { label: "2014", value: "2014" },
      { label: "2015", value: "2015" },
      { label: "2016", value: "2016" },
      { label: "2017", value: "2017" },
      { label: "2018", value: "2018" },
      { label: "2019", value: "2019" },
      { label: "2020", value: "2020" },
      { label: "2021", value: "2021" },
      { label: "2022", value: "2022" },
      { label: "2023", value: "2023" },
      { label: "2024", value: "2024" },
      { label: "2025", value: "2025" },
    ];

    this.type = [
      { label: "National Championships", value: "National Championships" },
      { label: "National Games", value: "National Games" },
      { label: "NRAT/WNRAT", value: "NRAT" },
      { label: "City/Zonal", value: "City/Zonal" },
      { label: "Selection Trials", value: "Selection Trials" },
    ];
  }

  ngOnInit(): void {
    this.getResults();
  }

  getResults() {
    const url =
      this.global.basePath +
      "common/circularlist?modelType=result&type=" +
      this.selectedType +
      "&year=" +
      this.selectedYear;
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.circular;
      this.ResultData = data;
    });
  }

  toLink(link:any){
    window.open( link,"_blank")
  }
}
